<template>
  <div class="dashboard wrap">
    <h1>
      Дежурно-диспетчерские службы<br />
      МО г. Южно-Сахалинск
    </h1>
    <CurrentDate></CurrentDate>

    <!-- <pre>{{parentIdList}}</pre> -->

    <div class="columnContainer">
      <div
        class="columnContainer_item"
        v-for="(It, idx) in parentIdList"
        :key="idx"
      >
        <DDSCard :It="It" :per-row="2"> </DDSCard>
      </div>
    </div>
  </div>
</template>

<script>
import DDSCard from "@/components/DDSCard";
import CurrentDate from "@/components/CurrentDate";
import { EmployeeApi } from "@/api/EmployeeApi";
import CONFIG from "@/config";

export default {
  name: "DDS",
  components: {
    DDSCard,
    CurrentDate,
  },
  data() {
    return {
      parentIdList: [],
    };
  },
  async beforeRouteEnter(to, from, next) {
    let data = await EmployeeApi.getList({
      parentId: CONFIG.DDS_ROOT_ID,
    });
    next((vm) => {
      vm.parentIdList = data.content;
    });
  },
};
</script>

<style>
/*
.grid {
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(3,1fr);
  grid-template-rows: masonry;
}
*/

.columnContainer {
  column-count: 3;
  column-gap: 2rem;
}

.columnContainer_item {
  /* FIX */
  display: inline-block;
  width: 100%;
  margin: 0.5rem 0;
}
</style>
